// extracted by mini-css-extract-plugin
export default {"title":"topHighest_title__fBxkk"};